import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const modulesFiles = require.context("./modules", true, /\.js$/);

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1"); // remove .js
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

export default new Vuex.Store({
  state: {
    isLoading: false,
    Alert: {
      isShow: false,
      type: null,
      width: null,
      msg: null,
      icon: null,
      clickTime: null,
    },
    Dialog: {
      isShow: false,
      msg: null,
      answer: false,
      clickTime: null,
    },
    RouteItem: [],
  },
  getters: {},
  mutations: {
    SetisLoading(state, bool) {
      state.isLoading = bool;
    },
    SetAlert(state, value) {
      state.Alert.isShow = value[0];
      state.Alert.type = value[1];
      state.Alert.msg = value[2];
      state.Alert.width = 120 + value[2].length * 15;
      state.Alert.icon = value[3];
      state.Alert.clickTime = Date.now();
    },
    SetDialog(state, value) {
      state.Dialog.isShow = value[0];
      state.Dialog.msg = value[1];
      state.Dialog.answer = value[2];
      state.Dialog.clickTime = Date.now();
    },
    SetRouteItem(state, value) {
      state.RouteItem = value;
    },
  },
  actions: {
    SetisLoading(context, bool) {
      context.commit("SetisLoading", bool);
    },
    SetAlert(context, value) {
      context.commit("SetAlert", value);
    },
    SetDialog(context, value) {
      context.commit("SetDialog", value);
    },
  },
  modules,
});
